import { Box, Stack } from '@mui/material'
import React from 'react'
import { dayNames } from '@fedsim/helpers'

import { Caption, CostRow, HeaderTertiary } from '../../typography'
import { ImageBlock } from '../../image-block'
import { AvatarStack } from '../../namebar';
import { SPACING } from '../../typography'

import FrequencyIcon from '@mui/icons-material/InsertInvitation';
import TvIcon from '@mui/icons-material/Tv';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'

const showItems = (title = '', items = []) =>
  (items.length > 0 && (
    <Caption sx={{ mr: 2 }}>
      <strong>{title}</strong>: {items.map(item => item.name).join(',')}
    </Caption>
  )) ||
  null

const getOrdinalNum = n =>
  n +
  (n > 0
    ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10]
    : '')

export function ShowBlock(props) {
  const {
    brands = [],
    authority = [],
    commentators = [],
    interviewers = [],
    frequency = 'Weekly',
    weekIndex = false,
    monthIndex = false,
    dayIndex = false,
    special = false,
    income = 0
  } = props
  const broacastType = special ? 'Global Broadcast' : 'Network'
  let returnString = ''
  let suffix = `${dayNames[dayIndex]}`

  if (frequency === 'weekly') {
    returnString = 'Weekly'
  }
  if (frequency === 'monthly') {
    returnString = 'Monthly'

    suffix = `${getOrdinalNum(weekIndex)} Week, ${dayNames[dayIndex]}`
  }
  if (frequency === 'yearly') {
    returnString = 'Yearly'
    const month = new Date(new Date().getFullYear(), monthIndex, 1).toLocaleString('default', { month: 'long' })

    suffix = `${getOrdinalNum(weekIndex + 1)} Week, ${dayNames[dayIndex]}, ${month}`
  }
  return (
    <>
      <Stack spacing={SPACING}>
        <AvatarStack collection={brands} />
        <Stack
          minWidth={240}
          alignItems="center"
          justifyContent="space-between"
          direction="row">
          <CalendarMonthIcon /><Caption>{suffix}</Caption></Stack>
        <Stack
          minWidth={240}
          alignItems="center"
          justifyContent="space-between"
          direction="row"><FrequencyIcon /><Caption>{returnString}</Caption></Stack>
        <Stack
          minWidth={240}
          alignItems="center"
          justifyContent="space-between"
          direction="row"><TvIcon /><Caption>{broacastType}</Caption></Stack>
        <CostRow label="Income" value={income} />
        {showItems('Authority', authority)}
        {showItems('Commentators', commentators)}
        {showItems('Interviewers', interviewers)}
      </Stack>
    </>
  )
}
export const ShowItem = props => {
  const {
    children,
    image = '',
    cardImage = '',
    name,
    backgroundColor,
    color
  } = props
  {
    const backgroundImage = `url(${cardImage}) cover no-repeat`

    return (
      <Stack
        spacing={SPACING}
        sx={{
          color,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row-reverse",
          flexWrap: {
            xs: "nowrap",
            sm: "nowrap",
            md: "wrap"
          }
        }}>
        <ImageBlock image={image} backgroundColor={backgroundColor} />
        <Stack sx={{ color, minWidth: 220 }} spacing={0.5}>
          <HeaderTertiary>{name}</HeaderTertiary>
          <ShowBlock {...props} />
        </Stack>
        <Box
          sx={{
            display: 'block',
            backgroundImage,
            height: '100%',
            width: '100%'
          }}
        />
        {children}
      </Stack>
    )
  }
}
